import { useEffect } from 'react';
import { useWatch } from 'react-hook-form';
import { useAccountFormStore } from '../store/accountFormStore';

const useAccountFormZustandPersist = (
    accountId,
    {
        control,
        setValue,
        reset,
        exclude = [],
        validate = false,
        dirty = false,
        touch = false
    }
) => {
    const watchedValues = useWatch({ control });
    const { getAccountByAccountId, upsertAccount } = useAccountFormStore();

    useEffect(() => {
        if (accountId) {
            const account = getAccountByAccountId(accountId);
            if (account) {
                Object.keys(account).forEach((key) => {
                    const shouldSet = !exclude.includes(key);
                    if (shouldSet) {
                        let value = account[key];
                        if (key == 'asOfDate' && value) {
                            value = new Date(account[key]);
                        }
                        setValue(key, value, {
                            shouldValidate: validate,
                            shouldDirty: dirty,
                            shouldTouch: touch
                        });
                    }
                });
            } else {
                reset();
            }
        }
    }, [accountId, setValue]);

    useEffect(() => {
        if (watchedValues?.accountId) {
            const values = exclude.length
                ? Object.entries(watchedValues)
                    .filter(([key]) => !exclude.includes(key))
                    .reduce((obj, [key, val]) => Object.assign(obj, { [key]: val }), {})
                : Object.assign({}, watchedValues);

            if (Object.entries(values).length) {
                upsertAccount(values);
            }
        }
    }, [watchedValues]);

    return {};
};

export default useAccountFormZustandPersist;
